export default function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay || 0);
  };
};



// WEBPACK FOOTER //
// ./src/utils/debounce.js